import React from "react";
import { CITIES } from "../../data";

const Item = ({ city }) => (
  <span className="inline-flex items-center">
    <span className="font-display text-2xl md:text-4xl font-extrabold tracking-tight px-6 md:px-8">
      {city}
    </span>
    <span className="h-2 w-2 rounded-full bg-[#54BCE6]" />
  </span>
);

export const Marquee = () => {
  const loop = [...CITIES, ...CITIES];
  return (
    <section data-testid="marquee-section" className="relative bg-[#133955] text-white py-7 overflow-hidden grain">
      <div className="relative z-10 marquee-track" aria-hidden="true">
        {loop.map((c, i) => (
          <Item key={i} city={c} />
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-10 md:w-16 bg-gradient-to-r from-[#133955] to-transparent z-20" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-10 md:w-16 bg-gradient-to-l from-[#133955] to-transparent z-20" />
    </section>
  );
};
